var _paymentMethodPrice;
const getCartPrices = (prices)=>({
        discountPrice: prices.discount.amount,
        paymentMethodPrice: (_paymentMethodPrice = prices.paymentMethodPrice) !== null && _paymentMethodPrice !== void 0 ? _paymentMethodPrice : undefined,
        subTotalPrice: prices.subtotal,
        shippingPrice: prices.shippingPrice,
        totalPrice: prices.gross
    })
;

export { getCartPrices };
//# sourceMappingURL=get-cart-prices.js.map
